unit Essentials.Web.CustomNames.Editor;

interface

uses
  System.SysUtils,
  System.Classes,
  System.Generics.Collections,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Grids,
  WEBLib.ExtCtrls,
  WEBLib.DB;

type
  TEssentialsCustomNamesEditor = class(TCoreWebForm)
    CustomNamesSource: TDataSource;
    EssentialsCustomNamesEditorTable: TDBTableControl;
    CustomNamesEdit: TDBEdit;
    CustomNamesAddButton: TButton;
    CustomNamesCancelButton: TButton;
    CustomNamesSaveButton: TButton;
    EntitySelector: TDBLookupComboBox;
    FieldSelector: TDBLookupComboBox;
    procedure CustomNamesAddButtonClick(Sender: TObject);
    procedure CustomNamesCancelButtonClick(Sender: TObject);
    procedure CustomNamesSaveButtonClick(Sender: TObject);
    procedure CustomNamesSourceStateChange(Sender: TObject);
    procedure EntitySelectorChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
  private
    [Async]
    procedure LoadEntityList; async;
    [Async]
    procedure SaveCustomNames; async;
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsCustomNamesEditor: TEssentialsCustomNamesEditor;

implementation

{$R *.dfm}


uses
{ TODO : ConnectionModule - only needed in design mode in EssentialsDemoWeb App - DO NOT leave this here when running }
//  ConnectionModule,
  Essentials.Web.Shared,
  Essentials.Shared,
  SMX.Web.Utils;

procedure TEssentialsCustomNamesEditor.CustomNamesAddButtonClick(Sender:
    TObject);
begin
 CustomNamesSource.DataSet.Insert;
end;

procedure TEssentialsCustomNamesEditor.CustomNamesCancelButtonClick(Sender:
    TObject);
begin
  CustomNamesSource.DataSet.Cancel;
end;

procedure TEssentialsCustomNamesEditor.CustomNamesSaveButtonClick(Sender:
    TObject);
begin
 SaveCustomNames;
end;

procedure TEssentialsCustomNamesEditor.CustomNamesSourceStateChange(Sender:
    TObject);
begin
  CustomNamesSaveButton.Enabled := CustomNamesSource.State in dsEditModes;
  CustomNamesCancelButton.Enabled := CustomNamesSaveButton.Enabled;
  CustomNamesAddButton.Enabled := not CustomNamesSaveButton.Enabled;
end;

procedure TEssentialsCustomNamesEditor.EntitySelectorChange(Sender: TObject);
var
  selectedValue: string;
  lFields: TList<string>;
  fld: string;
begin
  selectedValue := EntitySelector.Value;
  FieldSelector.LookupValues.Clear;

  lFields := EssentialsManager.LookUpManager.RegisteredFields[selectedValue];

  if Assigned(lFields) then
  begin
    for fld in lFields do
      FieldSelector.LookupValues.AddPair(fld, TUtils.SplitOnCaps(fld));
  end;

end;

procedure TEssentialsCustomNamesEditor.LoadEntityList;
var
  lDef: TdtoLookupDef;
  lName, lCustom: string;
  lAssigned: Boolean;
begin
  for lDef in EssentialsManager.LookUpManager.RegisteredEntities do
  begin
    lName := lDef.EntityClassName;
    lAssigned := Assigned(EssentialsManager.CustomNamesManager);
    if lAssigned then
    begin
      lCustom := EssentialsManager.CustomNamesManager.EntityCustomName(lName);
      EntitySelector.LookupValues.AddPair(lName, lCustom);
    end;
  end;

end;

procedure TEssentialsCustomNamesEditor.SaveCustomNames;
begin
  Await(EssentialsManager.CustomNamesManager.SaveChanges);
end;

procedure TEssentialsCustomNamesEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  CustomNamesSource.DataSet := EssentialsManager.CustomNamesManager.NamesDataset;
  CustomNamesSaveButton.Enabled := False;
  CustomNamesCancelButton.Enabled := False;
  LoadEntityList;
end;

procedure TEssentialsCustomNamesEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  EssentialsCustomNamesEditorTable := TDBTableControl.Create('essentials.customnames.editor.table');
  CustomNamesEdit := TDBEdit.Create('essentials.customnames.customname.edit');
  CustomNamesAddButton := TButton.Create('essentials.customnames.add.button');
  CustomNamesCancelButton := TButton.Create('essentials.customnames.cancel.button');
  CustomNamesSaveButton := TButton.Create('essentials.customnames.save.button');
  EntitySelector := TDBLookupComboBox.Create('essentials.customnames.entity.selector');
  FieldSelector := TDBLookupComboBox.Create('essentials.customnames.field.selector');
  CustomNamesSource := TDataSource.Create(Self);

  EssentialsCustomNamesEditorTable.BeforeLoadDFMValues;
  CustomNamesEdit.BeforeLoadDFMValues;
  CustomNamesAddButton.BeforeLoadDFMValues;
  CustomNamesCancelButton.BeforeLoadDFMValues;
  CustomNamesSaveButton.BeforeLoadDFMValues;
  EntitySelector.BeforeLoadDFMValues;
  FieldSelector.BeforeLoadDFMValues;
  CustomNamesSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    EssentialsCustomNamesEditorTable.SetParentComponent(Self);
    EssentialsCustomNamesEditorTable.Name := 'EssentialsCustomNamesEditorTable';
    EssentialsCustomNamesEditorTable.Left := 111;
    EssentialsCustomNamesEditorTable.Top := 112;
    EssentialsCustomNamesEditorTable.Width := 481;
    EssentialsCustomNamesEditorTable.Height := 200;
    EssentialsCustomNamesEditorTable.HeightStyle := ssAuto;
    EssentialsCustomNamesEditorTable.WidthStyle := ssAuto;
    EssentialsCustomNamesEditorTable.BorderColor := clSilver;
    EssentialsCustomNamesEditorTable.ChildOrder := 3;
    EssentialsCustomNamesEditorTable.ElementFont := efCSS;
    EssentialsCustomNamesEditorTable.ElementHeaderClassName := 'thead-light';
    EssentialsCustomNamesEditorTable.ElementPosition := epIgnore;
    EssentialsCustomNamesEditorTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsCustomNamesEditorTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsCustomNamesEditorTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsCustomNamesEditorTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsCustomNamesEditorTable.Footer.InputElementClassName := 'form-control';
    EssentialsCustomNamesEditorTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsCustomNamesEditorTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsCustomNamesEditorTable.Footer.ListElementClassName := 'pagination';
    EssentialsCustomNamesEditorTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsCustomNamesEditorTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsCustomNamesEditorTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsCustomNamesEditorTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsCustomNamesEditorTable.Header.DropDownElementClassName := 'form-control';
    EssentialsCustomNamesEditorTable.Header.InputElementClassName := 'form-control';
    EssentialsCustomNamesEditorTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsCustomNamesEditorTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsCustomNamesEditorTable.Header.ListElementClassName := 'pagination';
    EssentialsCustomNamesEditorTable.Header.ListItemElementClassName := 'page-item';
    EssentialsCustomNamesEditorTable.Header.ListLinkElementClassName := 'page-link';
    EssentialsCustomNamesEditorTable.Columns.Clear;
    with EssentialsCustomNamesEditorTable.Columns.Add do
    begin
      DataField := 'EntityClassName';
      Title := 'Entity';
      Width := 150;
    end;
    with EssentialsCustomNamesEditorTable.Columns.Add do
    begin
      DataField := 'FieldName';
      Title := 'Field';
      Width := 20;
    end;
    with EssentialsCustomNamesEditorTable.Columns.Add do
    begin
      DataField := 'CustomName';
      Title := 'Custom Name';
    end;
    EssentialsCustomNamesEditorTable.DataSource := CustomNamesSource;
    CustomNamesEdit.SetParentComponent(Self);
    CustomNamesEdit.Name := 'CustomNamesEdit';
    CustomNamesEdit.Left := 375;
    CustomNamesEdit.Top := 368;
    CustomNamesEdit.Width := 242;
    CustomNamesEdit.Height := 22;
    CustomNamesEdit.ChildOrder := 4;
    CustomNamesEdit.ElementClassName := 'form-control';
    CustomNamesEdit.ElementFont := efCSS;
    CustomNamesEdit.ElementPosition := epIgnore;
    CustomNamesEdit.HeightStyle := ssAuto;
    CustomNamesEdit.HeightPercent := 100.000000000000000000;
    CustomNamesEdit.Text := 'CustomNamesEdit';
    CustomNamesEdit.WidthStyle := ssAuto;
    CustomNamesEdit.WidthPercent := 100.000000000000000000;
    CustomNamesEdit.DataField := 'CustomName';
    CustomNamesEdit.DataSource := CustomNamesSource;
    CustomNamesAddButton.SetParentComponent(Self);
    CustomNamesAddButton.Name := 'CustomNamesAddButton';
    CustomNamesAddButton.Left := 111;
    CustomNamesAddButton.Top := 416;
    CustomNamesAddButton.Width := 96;
    CustomNamesAddButton.Height := 25;
    CustomNamesAddButton.Caption := 'Add';
    CustomNamesAddButton.ChildOrder := 7;
    CustomNamesAddButton.ElementClassName := 'btn btn-light';
    CustomNamesAddButton.ElementFont := efCSS;
    CustomNamesAddButton.ElementPosition := epIgnore;
    CustomNamesAddButton.HeightStyle := ssAuto;
    CustomNamesAddButton.HeightPercent := 100.000000000000000000;
    CustomNamesAddButton.WidthStyle := ssAuto;
    CustomNamesAddButton.WidthPercent := 100.000000000000000000;
    SetEvent(CustomNamesAddButton, Self, 'OnClick', 'CustomNamesAddButtonClick');
    CustomNamesCancelButton.SetParentComponent(Self);
    CustomNamesCancelButton.Name := 'CustomNamesCancelButton';
    CustomNamesCancelButton.Left := 226;
    CustomNamesCancelButton.Top := 416;
    CustomNamesCancelButton.Width := 96;
    CustomNamesCancelButton.Height := 25;
    CustomNamesCancelButton.Caption := 'Cancel';
    CustomNamesCancelButton.ChildOrder := 7;
    CustomNamesCancelButton.ElementClassName := 'btn btn-light';
    CustomNamesCancelButton.ElementFont := efCSS;
    CustomNamesCancelButton.ElementPosition := epIgnore;
    CustomNamesCancelButton.HeightStyle := ssAuto;
    CustomNamesCancelButton.HeightPercent := 100.000000000000000000;
    CustomNamesCancelButton.WidthStyle := ssAuto;
    CustomNamesCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(CustomNamesCancelButton, Self, 'OnClick', 'CustomNamesCancelButtonClick');
    CustomNamesSaveButton.SetParentComponent(Self);
    CustomNamesSaveButton.Name := 'CustomNamesSaveButton';
    CustomNamesSaveButton.Left := 328;
    CustomNamesSaveButton.Top := 416;
    CustomNamesSaveButton.Width := 96;
    CustomNamesSaveButton.Height := 25;
    CustomNamesSaveButton.Caption := 'Save';
    CustomNamesSaveButton.ChildOrder := 7;
    CustomNamesSaveButton.ElementClassName := 'btn btn-light';
    CustomNamesSaveButton.ElementFont := efCSS;
    CustomNamesSaveButton.ElementPosition := epIgnore;
    CustomNamesSaveButton.HeightStyle := ssAuto;
    CustomNamesSaveButton.HeightPercent := 100.000000000000000000;
    CustomNamesSaveButton.WidthStyle := ssAuto;
    CustomNamesSaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(CustomNamesSaveButton, Self, 'OnClick', 'CustomNamesSaveButtonClick');
    EntitySelector.SetParentComponent(Self);
    EntitySelector.Name := 'EntitySelector';
    EntitySelector.Left := 62;
    EntitySelector.Top := 368;
    EntitySelector.Width := 145;
    EntitySelector.Height := 22;
    EntitySelector.ElementClassName := 'custom-select';
    EntitySelector.ElementFont := efCSS;
    EntitySelector.HeightPercent := 100.000000000000000000;
    EntitySelector.WidthPercent := 100.000000000000000000;
    SetEvent(EntitySelector, Self, 'OnChange', 'EntitySelectorChange');
    EntitySelector.DataField := 'EntityClassName';
    EntitySelector.DataSource := CustomNamesSource;
    FieldSelector.SetParentComponent(Self);
    FieldSelector.Name := 'FieldSelector';
    FieldSelector.Left := 216;
    FieldSelector.Top := 368;
    FieldSelector.Width := 145;
    FieldSelector.Height := 22;
    FieldSelector.ElementClassName := 'custom-select';
    FieldSelector.ElementFont := efCSS;
    FieldSelector.HeightPercent := 100.000000000000000000;
    FieldSelector.WidthPercent := 100.000000000000000000;
    FieldSelector.DataField := 'FieldName';
    FieldSelector.DataSource := CustomNamesSource;
    CustomNamesSource.SetParentComponent(Self);
    CustomNamesSource.Name := 'CustomNamesSource';
    SetEvent(CustomNamesSource, Self, 'OnStateChange', 'CustomNamesSourceStateChange');
    CustomNamesSource.Left := 64;
    CustomNamesSource.Top := 56;
  finally
    EssentialsCustomNamesEditorTable.AfterLoadDFMValues;
    CustomNamesEdit.AfterLoadDFMValues;
    CustomNamesAddButton.AfterLoadDFMValues;
    CustomNamesCancelButton.AfterLoadDFMValues;
    CustomNamesSaveButton.AfterLoadDFMValues;
    EntitySelector.AfterLoadDFMValues;
    FieldSelector.AfterLoadDFMValues;
    CustomNamesSource.AfterLoadDFMValues;
  end;
end;

end.

